let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lQ681")).then(() => parcelRequire('1R9iT'));